export enum SONPCode {
  SONPC = 'SONPC',
  SONPNC = 'SONPNC',
  SONPIP = 'SONPIP',
  SONPUS = 'SONPUS',
  SONPUE = 'SONPUE',
  SONPUR = 'SONPUR',
}
